import React, { useState, useEffect } from "react";
import LeaveDecisionModal from "../../components/LeaveDecisionModal";
import LeaveApprovalTable from "../../components/LeaveApprovalTable";
import LeaveTracker from "../../components/LeaveTracker";
import LeaveBalanceViewer from "../../components/LeaveBalanceViewer";
import Sidebar from "../../components/MasterSideBar";
import TopBar from "../../components/TopbarNav";
import Card from "../../components/card";
import LeaveRequestForm from "../../components/LeaveRequestForm"; // 👈 import form

export default function LeaveRequestsPage() {
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [feedbackMsg, setFeedbackMsg] = useState("");
  const [showLeaveForm, setShowLeaveForm] = useState(false);

  const trackerMonths = ["July", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const departments = ["HRs", "PTAs", "FS", "General"];

  const leaveBalance = [
    ["Maria Flavia", "Lorna Naula", "Saul Lemusi"],
    ["Maria Flavia", "Lorna Naula", "John Magoro"],
  ];

  // Retrieve user and token from localStorage
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = user ? user.role : null;
  const staffId = user ? user.id : null; // 👈 needed for form

  useEffect(() => {
    const fetchLeaveRequests = async () => {
      try {
        const res = await fetch(
          "https://ims.holdthechild.net/api/leave-request",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();
        if (!res.ok || !data.success) throw new Error("Failed to fetch");
        setLeaveRequests(data.data);
      } catch (err) {
        console.error("Error loading leave requests:", err);
        setFeedbackMsg("⚠️ Failed to load leave requests.");
      }
    };
    fetchLeaveRequests();
  }, [token]); // Add token as a dependency

  const approvedCount = leaveRequests.filter(
    (req) => req.status === "Approved"
  ).length;
  const rejectedCount = leaveRequests.filter(
    (req) => req.status === "Rejected"
  ).length;
  const pendingCount = leaveRequests.filter(
    (req) => req.status === "Pending" || req.status === "On Hold"
  ).length;

  const totalRequests = leaveRequests.length;
  const approvedPercent =
    totalRequests > 0 ? ((approvedCount / totalRequests) * 100).toFixed(1) : 0;
  const rejectedPercent =
    totalRequests > 0 ? ((rejectedCount / totalRequests) * 100).toFixed(1) : 0;
  const pendingPercent =
    totalRequests > 0 ? ((pendingCount / totalRequests) * 100).toFixed(1) : 0;

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const handleSubmitDecision = async ({ status, comment }) => {
    try {
      const res = await fetch(
        `https://ims.holdthechild.net/api/leave-request/${selectedRequest._id}/status`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ status, comment }), // Changed hrComment to comment
        }
      );

      const updated = await res.json();

      if (!res.ok) throw new Error(updated.message || "Update failed");

      setFeedbackMsg("✅ Leave updated successfully");
      setShowModal(false);

      setLeaveRequests((prev) =>
        prev.map((req) =>
          req._id === selectedRequest._id ? updated.leaveRequest : req
        )
      );
    } catch (err) {
      console.error(err);
      setFeedbackMsg("❌ Failed to update leave.");
    }
  };

  return (
    <div className="flex min-h-screen w-full bg-gray-50 font-sans">
      <Sidebar activePage="Leave Requests" onLogout={handleLogout} />
      <div className="flex-1 relative overflow-y-auto md:ml-64">
        <div className="fixed top-0 left-0 right-0 z-10 md:ml-64">
          <TopBar />
        </div>
        <main className="pt-20 px-4 md:px-6">

          <div className="flex justify-between items-center mb-6">
            <h1 className="text-xl font-bold text-gray-700">
              Leave Requests Page
            </h1>
            <button
              onClick={() => setShowLeaveForm(true)}
              className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600"
            >
              Request Leave
            </button>
          </div>



          {showLeaveForm && staffId && token && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
              onClick={() => setShowLeaveForm(false)}
            >
              <div
                className="bg-white rounded-xl p-6 max-w-2xl w-full mx-4 relative overflow-y-auto max-h-[90vh]"

                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => setShowLeaveForm(false)}
                  className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-2xl font-bold"
                >
                  &times;
                </button>
                <LeaveRequestForm staffId={staffId} token={token} />
              </div>
            </div>
          )}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <LeaveTracker departments={departments} trackerMonths={trackerMonths} />
            <div className="flex flex-col gap-4">
              <Card
                title="Requests Accepted"
                value={approvedCount}
                icon={<span className="text-green-500 text-xl">🉑</span>}
                progress={Number(approvedPercent)}
                size="small"
              />
              <Card
                title="Requests Rejected"
                value={rejectedCount}
                icon={<span className="text-red-500 text-xl">⛔️</span>}
                progress={Number(rejectedPercent)}
                size="small"
              />
              <Card
                title="Requests On Hold"
                value={pendingCount}
                icon={<span className="text-yellow-500 text-xl">⏳</span>}
                progress={Number(pendingPercent)}
                size="small"
              />
            </div>
          </div>
          <LeaveApprovalTable
            leaveRequests={leaveRequests}
            onTakeAction={(request) => {
              setSelectedRequest(request);
              setShowModal(true);
            }}
            feedbackMsg={feedbackMsg}
            showModal={showModal}
            LeaveDecisionModal={LeaveDecisionModal}
            selectedRequest={selectedRequest}
            onCloseModal={() => setShowModal(false)}
            onSubmitDecision={handleSubmitDecision}
            userRole={userRole} // <-- Pass userRole prop here
            token={token} // <-- Pass token prop here
          />
        </main>
      </div>
    </div>
  );
}